export default "/images/9784d53be0ec1a33098af290aba2c3c2.avif";